// extracted by mini-css-extract-plugin
export default {"logo":"Header_Logo_logo__JYdPi"};